import { useTranslation } from "react-i18next";
import { cn } from "@/lib/cn";

// Mirrors auth-stack.ts passwordPolicy. Renders a small ✓/✗ checklist
// so users see exactly which rule is failing instead of a generic
// Cognito "did not conform to policy" error.
const RULES = [
  { id: "min", key: "auth.passwordRules.min", test: (p: string) => p.length >= 10 },
  { id: "lower", key: "auth.passwordRules.lower", test: (p: string) => /[a-z]/.test(p) },
  { id: "upper", key: "auth.passwordRules.upper", test: (p: string) => /[A-Z]/.test(p) },
  { id: "digit", key: "auth.passwordRules.digit", test: (p: string) => /\d/.test(p) },
  { id: "symbol", key: "auth.passwordRules.symbol", test: (p: string) => /[^A-Za-z0-9]/.test(p) }
];

export function passwordMeetsPolicy(p: string): boolean {
  return RULES.every((r) => r.test(p));
}

export function PasswordRequirements({ password }: { password: string }) {
  const { t } = useTranslation();
  return (
    <ul className="text-xs space-y-0.5">
      {RULES.map((r) => {
        const ok = r.test(password);
        return (
          <li
            key={r.id}
            className={cn(
              "flex items-center gap-2",
              ok ? "text-green-700 dark:text-green-300" : "text-muted-foreground"
            )}
          >
            <span aria-hidden className="font-mono w-3 inline-block">
              {ok ? "✓" : "•"}
            </span>
            <span>{t(r.key)}</span>
          </li>
        );
      })}
    </ul>
  );
}
